import { AgentMessageMadDataSuggestionProps } from "./types";
import {
  type HandlerObject,
  type HandlerPath,
  useMadSDKSingular
} from "@madhive/mad-hooks";
import AgentMessageDataSuggestion from "./AgentMessage.DataSuggestion";
import { useMemo } from "react";

/**
 * Wrapper around `AgentMessage.DataSuggestion` that uses the `useMadSDKSingular` hook to
 * subscribe to form data and validation errors for a given collection and id.
 */
function AgentMessageMadDataSuggestion<Collection extends HandlerPath>({
  collection,
  id,
  ...props
}: AgentMessageMadDataSuggestionProps<Collection>) {
  const { pendingChanges, validationErrors, _changeVersion } =
    useMadSDKSingular(collection, id);
  const formData = useMemo(
    () => ({ ...(pendingChanges || ({} as HandlerObject<Collection>)) }),
    [_changeVersion, pendingChanges]
  );
  const title = useMemo(() => {
    if (typeof props.title === "function") {
      return props.title(formData);
    }
    return props.title;
  }, [props.title, formData]);
  return (
    <AgentMessageDataSuggestion<HandlerObject<Collection>>
      {...props}
      formData={formData}
      validationErrors={validationErrors}
      title={title}
    />
  );
}

AgentMessageMadDataSuggestion.displayName = "AgentMessage.MadDataSuggestion";

export default AgentMessageMadDataSuggestion;
